import './BasketPage.scss'

import { LeftCircleFilled } from '@ant-design/icons'
import { Button, Col, Layout, message, Row } from 'antd'
import { Content } from 'antd/es/layout/layout'
import Sider from 'antd/es/layout/Sider'
import CenteredLayout from 'components/centered-layout/CenteredLayout'
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { DEV_BACKEND_DOMAIN } from 'utils/const'

import BasketInfoTable from '../../components/basket-info-table/BasketInfoTable'
import BasketProductInfoTable from '../../components/basket-product-info-table/BasketProductInfoTable'
import EmptyBasket from '../../components/empty-basket/EmptyBasket'
import PaymentInfoCard from '../../components/payment-info-card/PaymentInfoCard'
import Spinner from '../../components/spinner/Spinner'
import AppContext from '../../context/AppContext'
import {
  SepetSatiri,
  useSepetiBosaltMutation,
  useSepetPaketDuzenleMutation,
  useSepetPaketSilMutation,
  useSepetQuery,
  useSepetUrunDuzenleMutation,
  useSepetUrunSilMutation,
} from '../../gql/GeneratedGraphqlTypes'
import useMediaQuery from '../../hooks/useMediaQuery'

const BasketPage = () => {
  const navigate = useNavigate()
  const { slug, token, okul } = useContext(AppContext)
  const showIndirimsizFiyat = okul?.indirimli_fiyat_gosterimi ?? false
  const [messageApi, contextHolder] = message.useMessage()
  const [isSinif] = useState(true)

  const { loading, data, error, refetch } = useSepetQuery({
    variables: { slug: slug! },
    fetchPolicy: 'network-only',
  })

  //const [updatedItems, setUpdatedItems] = useState<SepetSatiri[]>([])
  const [isBasketTableVisible, setIsBasketTableVisible] = useState<boolean>(true)
  const [isBasketDeleteVisible, setIsBasketDeleteVisible] = useState<boolean>(false)
  const [isDigital, setIsDigital] = useState<boolean>(false)
  const [isKirtasiye, setIsKirtasiye] = useState<boolean>(false)
  //const [duzenleSepetMutation] = useSepetPaketDuzenleMutation() //todo:{loading: mutationLoading},error: mutationError} bu tarz eklenebilir ihtiyaç durumunda
  const [silSepetMutation] = useSepetUrunSilMutation()
  const [sepetUrunDuzenleMutation] = useSepetUrunDuzenleMutation()
  const [sepetiBosalt] = useSepetiBosaltMutation()
  const [sepetPaketSil] = useSepetPaketSilMutation()
  const [sepetPaketDuzenleMutation] = useSepetPaketDuzenleMutation()
  const isMobile = useMediaQuery(768)
  const [studentInfo, setStudentInfo] = useState({
    studentName: '',
    studentSurname: '',
    digital: '',
    gender: 0,
  })
  const [fieldErrors, setFieldErrors] = useState<{
    studentName?: string
    studentSurname?: string
    digital?: string
    gender?: string
  }>({})
  const [siderMaxHeight, setSiderMaxHeight] = useState('100vh')

  // Sepetteki tüm ürünleri silme
  const handleClear = () => {
    let items = []
    if (Array.isArray(data?.sepetTest?.urunler)) {
      items.push(...(data?.sepetTest?.urunler as SepetSatiri[]))
    }
    try {
      sepetiBosalt({
        variables: {
          okulSlug: slug!,
        },
      })
      messageApi.success('Sepet başarılı bir şekilde silindi', 6)
    } catch (error) {
      messageApi.error(`${error}`, 6)
    }
  }

  // django odeme adimlarina gecis
  const handleUpdate = async () => {
    if (!okul?.odeme_varmi) {
      messageApi.error('Bu okul satışa açık değildir.', 6)
      return
    }

    const newErrors: typeof fieldErrors = {}

    if (studentInfo.studentName.trim() === '') {
      newErrors.studentName = 'Öğrenci adı boş geçilemez.'
    }
    if (studentInfo.studentSurname.trim() === '') {
      newErrors.studentSurname = 'Öğrenci soyadı boş geçilemez.'
    }
    if (isKirtasiye && studentInfo.gender === 0) {
      newErrors.gender = 'Lütfen cinsiyet kısmını doldurunuz.'
    }
    if (isDigital) {
      if (studentInfo.digital.length !== 7 && studentInfo.digital.length !== 9 && studentInfo.digital.length !== 11) {
        newErrors.digital = 'Lütfen geçerli bir T.C. Kimlik No veya Pasaport No giriniz.'
      }
    }

    if (Object.keys(newErrors).length > 0) {
      setFieldErrors(newErrors)
      return
    }
    setFieldErrors({})

    let savedItems = []
    if (data?.sepetTest?.sinif !== null) {
      if (Array.isArray(data?.sepetTest?.urunler)) {
        savedItems.push(...(data?.sepetTest?.urunler as SepetSatiri[]))

        // Sepet verisini Django'ya gönderimi yapılır
        // burası sepet kontrol adımı sepetten ürünler silinirse false göndeririz
        fetch(
          `https://${slug}.${DEV_BACKEND_DOMAIN}/sepet-kontrol/${token}/?isim=${
            studentInfo.studentName.trim() + '%20' + studentInfo.studentSurname.trim()
          }&tc=${studentInfo.digital}&cinsiyet=${studentInfo.gender === 0 ? '' : studentInfo.gender === 1 ? 'E' : 'K'}`,
        )
          .then((response) => {
            if (response.status === 200) {
              return response.json()
            } else {
              return response.json().then((errorData) => {
                const err: Error & { errorType?: string } = new Error(errorData.Error)
                err.errorType = errorData.ErrorType
                throw err
              })
            }
          })
          .then((data) => {
            const url = `https://${slug}.${DEV_BACKEND_DOMAIN}/token-to-session-auth/${token}/` // authentication django siteye geçiş
            window.location.href = url
          })
          .catch((error) => {
            if (error.errorType === 'kimlik_hatali') {
              setFieldErrors({ digital: 'T.C. Kimlik Numarası hatalı girilmiştir. Lütfen kontrol ediniz.' })
            } else {
              messageApi.error(error.errorType ? error.message : 'Sepetiniz kontrol edilirken bir hata oluştu.', 8)
            }
          })
      }
    } else {
      if (Array.isArray(data?.sepetTest?.urunler)) {
        savedItems.push(...(data?.sepetTest?.urunler as SepetSatiri[]))

        // Sepet verisini Django'ya gönderimi yapılır
        // burası sepet kontrol adımı sepetten ürünler silinirse false göndeririz
        fetch(`https://${slug}.${DEV_BACKEND_DOMAIN}/sepet-kontrol/${token}/`)
          .then((response) => {
            if (response.status === 200) {
              return response.json()
            } else {
              return response.json().then((errorData) => {
                const err: Error & { errorType?: string } = new Error(errorData.Error)
                err.errorType = errorData.ErrorType
                throw err
              })
            }
          })
          .then((data) => {
            const url = `https://${slug}.${DEV_BACKEND_DOMAIN}/token-to-session-auth/${token}/` // authentication django siteye geçiş
            window.location.href = url
          })
          .catch((error) => {
            messageApi.error(error.errorType ? error.message : 'Sepetiniz kontrol edilirken bir hata oluştu.', 8)
          })
      }
    }
    refetch()
  }

  //sepetteki sınıf ürünleri buradan siliniyor.
  if (isBasketDeleteVisible && Array.isArray(data?.sepetTest?.urunler)) {
    try {
      // const response =
      sepetPaketSil({
        variables: {
          okulSlug: slug!,
          sinifId: data?.sepetTest?.sinif?.id!,
        },
      })
      setIsBasketDeleteVisible((prevValue: boolean) => !prevValue)
      messageApi.success('Sınıf ürünleri başarılı bir şekilde sepetten silindi')
    } catch (error) {
      messageApi.error(`${error}`, 6)
    }
  }

  const handleGeriDonClick = () => {
    navigate(-1) // Önceki sayfaya geri dönme
  }

  //ürün adet değişimi satir_id geliyor.
  const handleChange = async (id: number, value: number) => {
    const matchedItem = data?.sepetTest?.urunler?.find((item) => item?.id === id)
    // Convert updatedItems to the appropriate type
    try {
      if (matchedItem!.sinif_id == null) {
        await sepetUrunDuzenleMutation({
          variables: {
            okulSlug: slug!,
            urun: { urun_id: matchedItem?.urun?.id!, adet: value, ogrenci_ismi: '' },
          },
        })
        messageApi.success('Ürün başarılı bir şekilde güncellendi.', 6)
      } else {
        const alfa = []

        for (let i = 0; i < data?.sepetTest?.urunler?.length!; i++) {
          const urunVeri = urun![i]

          // Her bir ürün verisini urunler dizisine ekle
          if (urunVeri?.id === matchedItem!.id) {
            alfa.push({
              urun_id: urunVeri?.urun?.id as number,
              adet: value,
              ogrenci_ismi: '',
            })
          } else {
            alfa.push({
              urun_id: urunVeri?.urun?.id as number,
              adet: urunVeri?.adet!,
              ogrenci_ismi: '',
            })
          }
        }

        await sepetPaketDuzenleMutation({
          variables: {
            okulSlug: slug!,
            sinifId: matchedItem!.sinif_id,
            urunler: alfa,
          },
        })

        messageApi.success('Ürün başarılı bir şekilde güncellendi', 6)
      }
    } catch (hata) {
      messageApi.error(`${hata}`, 6)
    }
  }

  //spesifik ürün silme işlemi
  const handleDeleteChange = async (id: number) => {
    const selectedUrun = data?.sepetTest?.urunler?.find((urun) => urun?.id === id)
    try {
      if (selectedUrun!.sinif_id == null) {
        await silSepetMutation({
          variables: {
            okulSlug: slug!,
            urunId: selectedUrun?.urun?.id!,
          },
        })
        messageApi.success('Ürün başarılı bir şekilde silindi', 6)
      } else {
        const urunler = []

        for (let i = 0; i < data?.sepetTest?.urunler?.length!; i++) {
          const urunVeri = urun![i]

          // Her bir ürün verisini urunler dizisine ekle
          if (urunVeri?.id === selectedUrun!.id) {
            urunler.push({
              urun_id: urunVeri?.urun?.id as number,
              adet: 0,
              ogrenci_ismi: '',
            })
          } else {
            urunler.push({
              urun_id: urunVeri?.urun?.id as number,
              adet: urunVeri?.adet!,
              ogrenci_ismi: '',
            })
          }
        }
        await sepetPaketDuzenleMutation({
          variables: {
            okulSlug: slug!,
            sinifId: selectedUrun!.sinif_id,
            urunler: urunler,
          },
        })

        messageApi.success('Ürün başarılı bir şekilde silindi', 6)
      }
    } catch (hata) {
      messageApi.error(`${hata}`, 6)
    }
  }

  // Sepet Stok Kontrol && Sepet satırlarından sınıfı belirle
  useEffect(() => {
    if (data && data.sepetTest && data.sepetTest.urunler) {
      // Sepet satırlarından sınıfı belirle.
      const hasSinifId = data.sepetTest.urunler.some((urun: SepetSatiri | null) => urun?.sinif_id)
      console.log(hasSinifId)
      // setIsSinif(hasSinifId)

      // Sepet'de stok kontrolü yap.
      data.sepetTest.urunler.map((satir) => {
        if (satir?.urun?.grup !== null && satir?.stok! < satir?.adet!) {
          // Eğer stok 0'dan küçük ise satırı silme işlemine tabi tut
          if (satir?.stok! <= 0) {
            handleDeleteChange(satir?.id!)
            messageApi.error(`${satir?.urun?.isim} ürününden stokta kalmadığı için sepetten silindi.`, 6)
          } else {
            handleChange(satir?.id!, satir?.stok!)
            messageApi.error(
              `${satir?.urun?.isim} ürününden stokta ${satir?.stok} kadar kaldı. Ürün Otomatik olarak sepette ${satir?.stok} adet ile güncellendi.`,
              6,
            )
          }
        }
      })
    }
  }, [data])

  // Sider Yüksekliği Ayarlama
  useEffect(() => {
    const desiredPercentage = 60 // Ekranda nereye kadar inmesi gerekli yüzdesi
    const windowHeight = window.innerHeight
    const calculatedHeight = `${(windowHeight * desiredPercentage) / 100}px`
    setSiderMaxHeight(calculatedHeight)
  }, [])

  if (loading) {
    // Show a loading indicator while the data is being fetched
    return (
      <CenteredLayout>
        <Spinner showSpinner={true} color={'red'} />
      </CenteredLayout>
    )
  }
  if (error) {
    messageApi.error(`${error}`, 2)
  }
  if (!data) {
    return null
  }
  const sepet = data.sepetTest
  if (!sepet || sepet.__typename !== 'Sepet') {
    return null
  }
  const urun = sepet.urunler // todo: bunu state'e çevirip cevap sonrası güncelleme yapmamız lazım
  if (!urun) {
    return null
  }
  if (!data?.sepetTest || data.sepetTest.urunler?.length === 0) {
    return (
      <CenteredLayout>
        <EmptyBasket />
      </CenteredLayout>
    )
  } else {
    return (
      <CenteredLayout>
        {contextHolder}
        <div className="basket-page-header">
          <h3>Sınıf İhtiyaç Listesi</h3>
        </div>
        <div className="basket-page">
          {isMobile ? (
            <>
              <Row gutter={20}>
                <Col className="basket-page-container-col" xs={24} md={18}>
                  {isSinif && (
                    <BasketInfoTable
                      data={sepet}
                      setIsBasketTableVisible={setIsBasketTableVisible}
                      setIsBasketDeleteVisible={setIsBasketDeleteVisible}
                      setIsDigital={setIsDigital}
                      setIsKirtasiye={setIsKirtasiye}
                      studentInfo={studentInfo}
                      setStudentInfo={setStudentInfo}
                      fieldErrors={fieldErrors}
                      setFieldErrors={setFieldErrors}
                    />
                  )}
                  {urun.map((urunler, index) => {
                    if (urunler) {
                      return (
                        <BasketProductInfoTable
                          key={index}
                          data={urunler}
                          onChanges={handleChange}
                          onDeleteChange={handleDeleteChange}
                          isBasketTableVisible={isBasketTableVisible}
                          showIndirimsizFiyat={showIndirimsizFiyat}
                        />
                      )
                    }
                    return null
                  })}
                  {urun?.length > 15 && <PaymentInfoCard data={sepet} onPurchase={handleUpdate} showIndirimsizFiyat={showIndirimsizFiyat} />}
                  <div style={{ display: 'flex', justifyContent: 'center', padding: '8px 0 100px' }}>
                    <Button type="primary" className="clear-basket" onClick={handleClear}>
                      Sepeti Boşalt
                    </Button>
                  </div>
                </Col>
                <PaymentInfoCard data={sepet} onPurchase={handleUpdate} showIndirimsizFiyat={showIndirimsizFiyat} />
              </Row>
            </>
          ) : (
            <Layout className="layout">
              <Content style={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
                <Row gutter={20}>
                  <Col xs={24} md={24}>
                    <BasketInfoTable
                      data={sepet}
                      setIsBasketTableVisible={setIsBasketTableVisible}
                      setIsBasketDeleteVisible={setIsBasketDeleteVisible}
                      setIsDigital={setIsDigital}
                      setIsKirtasiye={setIsKirtasiye}
                      studentInfo={studentInfo}
                      setStudentInfo={setStudentInfo}
                      fieldErrors={fieldErrors}
                      setFieldErrors={setFieldErrors}
                    />
                    <div className="basket-product-info-table">
                      <div className="basket-products-header">
                        <span>Alışveriş Sepetiniz </span>
                        <span>{data.sepetTest.urunler?.length} Çeşit Ürün </span>
                      </div>
                      <div className="products-titles">
                        <span className="first-span">Ürün</span>
                        <span className="second-span">Adet</span>
                        <span className="third-span">Tutar</span>
                        <span className="last-span">Kaldır</span>
                      </div>
                      {data.sepetTest.urunler?.map(
                        (urunler, index) =>
                          urunler && (
                            <BasketProductInfoTable
                              key={index}
                              data={urunler}
                              onChanges={handleChange}
                              onDeleteChange={handleDeleteChange}
                              isBasketTableVisible={isBasketTableVisible}
                              showIndirimsizFiyat={showIndirimsizFiyat}
                            />
                          ),
                      )}
                    </div>
                  </Col>
                </Row>
              </Content>
              {isMobile ? (
                <PaymentInfoCard data={sepet} onPurchase={handleUpdate} showIndirimsizFiyat={showIndirimsizFiyat} />
              ) : (
                <Sider
                  width={300}
                  style={{
                    overflow: 'auto',
                    maxHeight: siderMaxHeight, // Sider Max Yüksekliği
                    position: 'sticky',
                    top: 0,
                    paddingLeft: 10,
                    backgroundColor: 'transparent',
                  }}
                >
                  <Col xs={24} md={24} className="payment-info-mobile">
                    <PaymentInfoCard data={sepet} onPurchase={handleUpdate} showIndirimsizFiyat={showIndirimsizFiyat} />
                  </Col>
                </Sider>
              )}
            </Layout>
          )}
          {isMobile ? null : (
            <div className="basket-page-footer">
              <Button type={'primary'} className="back" icon={<LeftCircleFilled />} block onClick={handleGeriDonClick}>
                Geri Dön
              </Button>
              <Button type="primary" className="clear-basket" block onClick={handleClear}>
                Sepeti Boşalt
              </Button>
            </div>
          )}
        </div>
      </CenteredLayout>
    )
  }
}

export default BasketPage
